import React from "react";
import { motion } from "framer-motion";
import { FaEnvelope, FaWhatsapp, FaFacebook, FaTwitter, FaRegCopy } from "react-icons/fa";

import { IoMdClose } from "react-icons/io";
import { useState } from "react";

const SharePropertyModal = ({ isOpen, onClose, shareUrl }) => {
    const [copied, setCopied] = useState(false);

    const copyToClipboard = (e) => {
        e.stopPropagation(); // 🛑 Prevent click from triggering parent event
        navigator.clipboard.writeText(shareUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500); // Reset copied state after 1.5s
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                className="bg-white w-[600px] overflow-hidden rounded-lg shadow-lg py-10 px-5  relative"
            >
                {/* Close Button */}
                <button className="absolute top-4 right-4 text-gray-600 hover:text-black" onClick={onClose}>
                    <IoMdClose size={28} />
                </button>

                {/* Title */}
                <h2 className="text-2xl font-semibold text-center mb-6">Share Property</h2>

                {/* Social Media Icons */}
                <div className="flex justify-center space-x-8 mb-4">
                    <a href={`mailto:?subject=Check out this property&body=${shareUrl}`} target="_blank" rel="noopener noreferrer">
                        <div className="flex flex-col items-center">
                            <FaEnvelope className="text-gray-600 text-4xl hover:opacity-80" />
                            <span className="text-xs text-gray-600 mt-1">Email</span>
                        </div>
                    </a>

                    <a href={`https://wa.me/?text=${encodeURIComponent(shareUrl)}`} target="_blank" rel="noopener noreferrer">
                        <div className="flex flex-col items-center">
                            <FaWhatsapp className="text-green-500 text-4xl hover:opacity-80" />
                            <span className="text-xs text-gray-600 mt-1">WhatsApp</span>
                        </div>
                    </a>

                    <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`} target="_blank" rel="noopener noreferrer">
                        <div className="flex flex-col items-center">
                        <FaFacebook className="text-blue-600 text-4xl hover:opacity-80" />
                            <span className="text-xs text-gray-600 mt-1">Facebook</span>
                        </div>
                    </a>

                    <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}`} target="_blank" rel="noopener noreferrer">
                        <div className="flex flex-col items-center">
                            <FaTwitter className="text-black text-4xl hover:opacity-80" />
                            <span className="text-xs text-gray-600 mt-1">Twitter</span>
                        </div>
                    </a>
                </div>
                {/* Share Link & Copy Button */}
                <div className="flex items-center border rounded-lg p-3 text-lg">
                    <input type="text" value={shareUrl} readOnly className="flex-grow text-gray-700 bg-transparent outline-none px-2 text-lg" />
                    <button onClick={copyToClipboard} className="text-red-500 px-4 hover:text-red-600 flex items-center space-x-1">
                        <FaRegCopy className="text-xl" />
                        <span className="text-lg">{copied ? "Copied!" : "Copy"}</span>
                    </button>
                </div>
            </motion.div>
        </div>
    );
};

export default SharePropertyModal;
